module.exports = __webpack_public_path__ + "static/media/bg-shapes.27b1451e.svg";